import React, { useState, useEffect } from 'react';
import {
  Paragraph,
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter,
  Button,
  InputText
} from '@increasecard/typed-components';
import { LoadingOverlay } from '@card/commonlib';
import { useTranslation } from 'react-i18next';

export interface CreateShopModalProps {
  onCancel: () => void;
  onConfirm: (name: string) => void;
  visible: boolean;
  loading: boolean;
  error: string | null;
}

export function CreateShopModal({
  error,
  loading,
  onCancel,
  onConfirm,
  visible
}: CreateShopModalProps) {
  const { t } = useTranslation();
  const [name, setName] = useState('');

  // TODO(santi698): This should probably be always visible and unmounted instead of hidden to
  // avoid this ugly hacky hook
  useEffect(() => {
    if (!visible) setName('');
  }, [visible]);

  return (
    <Modal
      onCancel={() => {
        return;
      }}
      onClose={onCancel}
      onOk={() => {
        return;
      }}
      visible={visible}
    >
      <LoadingOverlay active={loading}>
        <ModalHeader>Agregar nueva sucursal</ModalHeader>
        <ModalContent scrollable>
          <InputText
            id="name"
            label={t('abm:Shops:CreateShopModal:shopName')}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
            value={name}
            width="240px"
          />
          <Paragraph>{error}</Paragraph>
          <Paragraph style={{ marginTop: '16px' }}>
            {t('abm:Shops:CreateShopModal:addingShopWarning')}
          </Paragraph>
        </ModalContent>
        <ModalFooter>
          <Button disabled={name.length === 0} onClick={() => onConfirm(name)}>
            {t('abm:Shops:CreateShopModal:confirm')}
          </Button>
          <Button buttonType="invisible" onClick={onCancel}>
            {t('abm:Shops:CreateShopModal:cancel')}
          </Button>
        </ModalFooter>
      </LoadingOverlay>
    </Modal>
  );
}
